import { render, staticRenderFns } from "./Conciseness.vue?vue&type=template&id=3ba5dee4&scoped=true&"
import script from "./Conciseness.vue?vue&type=script&lang=ts&"
export * from "./Conciseness.vue?vue&type=script&lang=ts&"
import style0 from "./Conciseness.vue?vue&type=style&index=0&id=3ba5dee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5dee4",
  null
  
)

export default component.exports